<template lang="pug">
  .transactions
    div.pa-4
      div.d-flex
        div(link @click="clickOpenReceipt(transaction.lead)")
          strong.s2.basic1000--text.transaction-title #
            | {{ transaction.lead.rid }} {{ transaction.uid }} {{ transaction.created | convertServerDate }}
        v-spacer
        v-chip(small outlined rounded class="text-uppercase my-auto button-AA-tiny" :color="transaction.paid ? 'success500': 'danger500'" :style="{ 'background-color': chipBackgroundColor(transaction.paid) + '!important' }") {{ transaction.paid ? $t('success'): $t('abandoned') }}
    v-divider.basic300
    div.pa-3
      v-row(no-gutters)
        v-col.pa-1
          p.mb-1.c1.basic600--text {{ $t('name') }}: {{ transaction.lead.name }}
          p.mb-1.c1.basic600--text {{ $t('phone') }}: {{ transaction.lead.phone | phoneFormat }}
          p.mb-1.c1.basic600--text(v-if="transaction.lead.email") {{ $t('email') }}: {{ transaction.lead.email }}
        v-col.pa-1
          p.mb-1.c1.primary--text {{ $t('amount') }}: {{ transaction.amount | displayPrice}}
          p.mb-1.c1.basic600--text {{ $t('method') }}: {{ transaction.gateway | paymentGatewayDisplay }} {{ transaction.channel | channel }}
          p.mb-1.c1.basic600--text(v-if="transaction.ref_id") {{ $t('reference_id') }}: {{ transaction.ref_id }}
          
    .modals
      product-invoice(v-if="openInvoiceDialog" :open.sync="openInvoiceDialog" :parentLead.sync="lead")
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ProductInvoice from '@/components/dialogs/database/ProductInvoice.vue'

export default {
  name: 'TransactionItem',
  props: ['transaction', 'index'],
  components: { ProductInvoice },
  data: () => ({
    openInvoiceDialog: false
  }),
  computed: {
    ...mapState('user', ['member']),
  },
  filters: {
    channel (val) {
      if (val) {
        if (val === 'cc') {
          return '(credit card)'
        } else if (val === 'fpx') {
          return '(FPX)'
        } else if (val === 'ewallet') {
          return '(e-wallet)'
        }
      }
      return null
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickOpenReceipt(lead) {
      this.$axios.get(`/leads/${lead.pid}/`)
        .then((resp) => {
          this.lead = resp.data
          this.openInvoiceDialog = true
        })
        .catch(() => {})
    },
    chipBackgroundColor (paid) {
      const theme = this.$vuetify.theme.themes[this.$theme]
      return paid ? theme.successT08 : theme.dangerT08
    }
  }
}
</script>

<style scoped>
  .transaction-title:hover{
    text-decoration: underline;
    cursor: pointer;
  }
  .border-bottom{
    border-bottom: 1px solid #f4f4f4;
    border-radius: 0 !important;
  }
</style>
